import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2cf232b5&scoped=true&"
import script from "./card?vue&type=script&lang=js&"
export * from "./card?vue&type=script&lang=js&"
import style0 from "./card.scss?vue&type=style&index=0&id=2cf232b5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf232b5",
  null
  
)

export default component.exports